// extracted by mini-css-extract-plugin
export var brand = "_8v-9";
export var compact = "_8v-6";
export var extraSmall = "_8v-7";
export var icon = "_8v-0";
export var large = "_8v-4";
export var light = "_8v-1";
export var medium = "_8v-5";
export var outline = "_8v-b";
export var primaryDark = "_8v-a";
export var primaryLight = "_8v-8";
export var primaryModern = "_8v-c";
export var success = "_8v-2";
export var successSolid = "_8v-3";